<template>
	<div class="tags-container" v-if="file">
		<i
			v-if="fileHasTagKey(file, 'status') && getTagValue(file, 'status') !== 'no_status'"
			class="material-icons"
			:style="{ color: tagStyleColor('status', getTagValue(file, 'status')) }"
			>fiber_manual_record</i
		>
		<div class="color-tags-container" v-for="colorTag in getColorTags(file)" :key="colorTag.id">
			<i
				v-if="![null, 'none'].includes(colorTag.value)"
				class="material-icons"
				:style="{ color: tagStyleColor('color', colorTag.value) }"
				>label</i
			>
		</div>
		<div v-if="fileHasTagKey(file, 'rating') && getTagValue(file, 'rating') !== 'none'" class="rating-tag-container">
			<i class="material-icons">star_rate</i>
			<span>{{ getTagValue(file, "rating") }}</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	props: {
		file: Object,
	},

	computed: {
		...mapGetters("Projects", ["tagStyleColor"]),
	},
	methods: {
		fileHasTagKey(file, key) {
			if (file.tags) return file.tags.find(tag => tag.name == key);
			else return false;
		},
		getTagValue(file, tagName) {
			let tag = file.tags.find(tag => tag.name == tagName);
			if (tag) return tag.value;
			else return null;
		},
		getColorTags(file) {
			let tags = file.tags.filter(tag => tag.name == "color");
			if (tags.length > 0) return tags;
			else return [];
		},
	},
};
</script>

<style lang="scss">
.tags-container {
	margin-left: auto;
	display: flex;
	align-items: center;
	i {
		width: 18px;
		font-size: 18px;
	}
	.rating-tag-container {
		display: flex;
		align-items: center;
		span {
			margin-top: 2px;
		}
	}
}
</style>
